import { createElementBlock as t, openBlock as i, createStaticVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function s(f, e) {
  return i(), t("svg", r, e[0] || (e[0] = [
    l('<rect width="21.5" height="15.5" x="1.25" y="4.25" fill="#fff" stroke="#F5F5F5" stroke-width=".5" rx="1.35"></rect><mask id="ic_flag_ie_svg__a" width="22" height="16" x="1" y="4" maskUnits="userSpaceOnUse" style="mask-type:luminance;"><rect width="21.5" height="15.5" x="1.25" y="4.25" fill="#fff" stroke="#fff" stroke-width=".5" rx="1.35"></rect></mask><g mask="url(#ic_flag_ie_svg__a)"><path fill="#FF8515" d="M15.951 4h7.476v16h-7.476z"></path><path fill="#07BB59" fill-rule="evenodd" d="M1 20h7.476V4H1z" clip-rule="evenodd"></path></g>', 3)
  ]));
}
const o = { render: s };
export {
  o as default,
  s as render
};
//# sourceMappingURL=ic_flag_ie-BqANNE3i.js.map
